import { USER_ACCESS, UserAccess } from "@/constants";

import DataDisplay, { DataDisplayComponent } from "./DataDisplay";

const RoleDisplay: DataDisplayComponent<UserAccess> = (props) => {
  const LANGUAGE_MAP = {
    [USER_ACCESS.ADMIN]: L.ROLE_NAME_ADMIN,
    [USER_ACCESS.USER]: L.ROLE_NAME_USER,
    [USER_ACCESS.READONLY]: L.ROLE_NAME_READONLY,
  };

  const PLURAL_LANGUAGE_MAP = {
    [USER_ACCESS.ADMIN]: L.ROLE_NAME_ADMIN_PLURAL,
    [USER_ACCESS.USER]: L.ROLE_NAME_USER_PLURAL,
    [USER_ACCESS.READONLY]: L.ROLE_NAME_READONLY_PLURAL,
  };

  return (
    <DataDisplay
      dictionary={LANGUAGE_MAP}
      pluralDictionary={PLURAL_LANGUAGE_MAP}
      {...props}
    />
  );
};

export default RoleDisplay;
